export default {
  caps: 1,
  cnc: 2,
  can: 14,
  ms: 16,
};
